// The panes of the view switch. Each view ticket replaces the placeholder of
// its view by its own component: `PANES[view] = MyView`. A pane gets the
// page's state, the way to change it, and the way to open an entity in the
// overlay; it reads its own data with its own hook.

import React from "react";

import { EntityClickHandler } from "../../types/entityRegistry";
import { AnalyticsState, AnalyticsView } from "./analyticsState";
import CapabilityMapView from "./CapabilityMap/CapabilityMapView";
import EcosystemView from "./Ecosystem/EcosystemView";
import MatrixView from "./Matrix/MatrixView";
import MissionsView from "./Missions/MissionsView";
import PartnershipsView from "./Partnerships/PartnershipsView";
import SupplyFlowView from "./SupplyFlow/SupplyFlowView";
import TreemapView from "./Treemap/TreemapView";

export interface AnalyticsPaneProps {
  // The address state: the selection, the view and every view's settings
  state: AnalyticsState;
  // Changes the address state; a view changes its own settings by
  // `onChange({ settings: { ...state.settings, <view>: next } })`
  onChange: (change: Partial<AnalyticsState>) => void;
  // Opens an entity in the 45% overlay beside the pane
  onOpenEntity: EntityClickHandler;
}

export const PANES: Record<AnalyticsView, React.FC<AnalyticsPaneProps>> = {
  "capability-map": CapabilityMapView,
  ecosystem: EcosystemView,
  "supply-flow": SupplyFlowView,
  treemap: TreemapView,
  matrix: MatrixView,
  missions: MissionsView,
  partnerships: PartnershipsView,
};
